"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_base_1 = require("../../types/tape-builder-base");
exports.artifactType = 'cashResponseTape';
exports.NodeConfigSchema = zod_1.z
    .object({
    cashBalancesFeedContextArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Slug for cash balances feed context artifact'),
    receivableResponseTapeArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Optional slug for receivable response tape artifact').optional(),
})
    .describe('DB node configuration');
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    externalFilename: zod_1.z.null(),
    type: zod_1.z.literal(exports.artifactType),
    loanProductSlug: zod_1.z.null(),
    creditFacilitySlug: zod_1.z.string(),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map